import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

type GaScriptsProps = {
	MembershipNumber: string | null | undefined;
	EmployerSector: string | null | undefined;
	Branch: string | null | undefined;
	Region: string | null | undefined;
	CategoryName: string | null | undefined;
};

/*
 * TODO: Update once nextJS is updated
 *
 * The Script tag from next/Script can't be remounted in the current version of nextJS.
 * Once we have updated to the latest version of nextJs we can change this to the following
 * In the latest version of NextJS the onReady function lets you
 * 
 * Execute code after the script's load event when it first loads and then after every subsequent component re-mount using the onReady property.
 * https://nextjs.org/docs/app/api-reference/components/script#onready
 * 
	<Script
		id="google-analytics-tags"
		onReady={() => {
			dataLayer.push({
				'event': 'loggedInMember',
				'membershipNumber': '${props.MembershipNumber ? props.MembershipNumber : null}'
			})
		}}
	/>;
*/

export default function GaScripts(props: GaScriptsProps): JSX.Element {
	const router = useRouter();

	const dataLayer = `
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
			'event': 'loggedInMember',
			'membershipNumber': '${props.MembershipNumber ? props.MembershipNumber : null}',
			'employerSector': '${props.EmployerSector ? props.EmployerSector : null}',
			'branch': '${props.Branch ? props.Branch : null}',
			'region': '${props.Region ? props.Region : null}',
			'categoryName': '${props.CategoryName ? props.CategoryName : null}'
		})
  `;

	useEffect(() => {
		const googleAnalyticsTags = document.getElementById('google-analytics-tags');
		googleAnalyticsTags?.replaceChildren(dataLayer);
	}, [props.MembershipNumber, router.asPath, dataLayer]);

	return (
		<>
			{props.MembershipNumber && (
				<Script id="google-analytics-tags-logged-in">
					{`
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({
							'event': 'loginSuccess',
							'membershipNumber': '${props.MembershipNumber}'
						})
					`}
				</Script>
			)}

			<Script id="google-analytics-tags">{dataLayer}</Script>
		</>
	);
}
